/**! media-query-parser | Tom Golden <oss@tom.bio> (https://tom.bio) | @license MIT  */
import {
	readMediaQueryList as r,
	readMediaQuery as t,
	readMediaCondition as e,
	readMediaFeature as o
} from './ast/ast.js'
import {
	flattenMediaQueryList as s,
	flattenMediaQuery as n,
	flattenMediaCondition as i
} from './flatten/flatten.js'
import {
	generateMediaQueryList as a,
	generateMediaQuery as u,
	generateMediaCondition as c,
	generateMediaFeature as p,
	generateValidValueToken as f
} from './generator/generator.js'
import {deleteUndefinedValues as m, invertParserError as l} from './internals.js'
import {lexer as x} from './lexer/lexer.js'
import {isParserError as d} from './utils.js'
export const parseMediaQueryList = t => {
	const e = x(t)
	return d(e) ? l(e) : m(s(r(e)))
}
export const parseMediaQuery = r => {
	const e = x(r)
	if (d(e)) return l(e)
	{
		const r = t(e)
		return d(r) ? l(r) : m(n(r))
	}
}
export const parseMediaCondition = r => {
	const t = x(r)
	if (d(t)) return l(t)
	{
		const r = e(t, !0)
		return d(r) ? l(r) : m(i(r))
	}
}
export const parseMediaFeature = r => {
	const t = x(r)
	if (d(t)) return l(t)
	{
		const r = o(t)
		return d(r) ? r : m(r)
	}
}
export const stringify = r => {
	switch (r.type) {
		case 'query-list':
			return a(r)
		case 'query':
			return u(r)
		case 'condition':
			return c(r)
		case 'feature':
			return p(r)
		default:
			return f(r)
	}
}
export * from './utils.js'
